export var Language;

(function (Language) {
  Language["Ru"] = "ru";
  Language["En"] = "en";
})(Language || (Language = {}));

export var UserRolesCode;

(function (UserRolesCode) {
  UserRolesCode["ADMIN"] = "ADMIN";
})(UserRolesCode || (UserRolesCode = {}));

export var FileErrorType;

(function (FileErrorType) {
  FileErrorType["FILE_SIZE"] = "FILE_SIZE";
  FileErrorType["FILE_TYPE"] = "FILE_TYPE";
  FileErrorType["NETWORK_FAIL"] = "NETWORK_FAIL";
})(FileErrorType || (FileErrorType = {}));

export var SocketEvent;

(function (SocketEvent) {
  SocketEvent["SocketDown"] = "SOCKET_DOWN";
})(SocketEvent || (SocketEvent = {}));

export var SocketConnectionState; // custom

(function (SocketConnectionState) {
  SocketConnectionState["CONNECTING"] = "Connecting";
  SocketConnectionState["CONNECTED"] = "Connected";
  SocketConnectionState["DISCONNECTED"] = "Disconnected";
})(SocketConnectionState || (SocketConnectionState = {}));

export var LoginVariant;

(function (LoginVariant) {
  LoginVariant["EMAIL"] = "EMAIL";
  LoginVariant["PHONE"] = "PHONE";
})(LoginVariant || (LoginVariant = {}));

export var Sex;

(function (Sex) {
  Sex["MALE"] = "MALE";
  Sex["FEMALE"] = "FEMALE";
})(Sex || (Sex = {}));